module.exports = __webpack_public_path__ + "static/sw-shirt-black-56035edf44e66f2a07b43523bf835ac2.jpg";